<template>
	<v-card dark style="border-radius:9px" color="grey lighten-2 elevation-0">
		<div class="repost-border">
			<v-card-title>
				<v-flex xs9 class="mb-1">
					<analytics-el-avatar
						:authorPic="_getAuthorPic(post.authorPic)"
						:authorName="_getSafeStr(post.authorName)"
						:isFullView="isFullView"
						:isRepost="true"
					/>
				</v-flex>

				<analytics-el-caption
					:post="post"
					:isFullView="isFullView"
					:isRepost="true"
				/>
			</v-card-title>

			<div class="px-3 pb-2">
				<analytics-el-graphics
					v-if="post.type"
					:SM="SM"
					:post="post"
					:isFullView="isFullView"
					:bypassPreFetch="bypassPreFetch"
					:preFetchImages="preFetchImages"
				/>
			</div>
		</div>
	</v-card>
</template>

<script>
import AnalyticsElAvatar from "./avatar"
import AnalyticsElCaption from "./caption"
import AnalyticsElGraphics from "./graphics"

import * as utils from "@/utils"

export default {
	name: "RepostUI",
	props: ["SM", "post", "isFullView", "bypassPreFetch", "preFetchImages"],
	components: {
		"analytics-el-avatar": AnalyticsElAvatar,
		"analytics-el-caption": AnalyticsElCaption,
		"analytics-el-graphics": AnalyticsElGraphics
	},
	methods: {
		_getAuthorPic(obj) {
			return utils._getAuthorPic(obj)
		},
		_getSafeStr(obj) {
			return utils._getSafeStr(obj)
		}
	}
}
</script>

<style>
.repost-border {
	border-left: 8px solid #bdbdbd;
}
</style>
